import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostDocumentsBuildings_buildingIdDocuments = z.any()
export type TagsPostDocumentsBuildings_buildingIdDocuments = z.infer<typeof tagsPostDocumentsBuildings_buildingIdDocuments>

export const descriptionPostDocumentsBuildings_buildingIdDocuments = z.any()
export type DescriptionPostDocumentsBuildings_buildingIdDocuments = z.infer<typeof descriptionPostDocumentsBuildings_buildingIdDocuments>

export const consumesPostDocumentsBuildings_buildingIdDocuments = z.any()
export type ConsumesPostDocumentsBuildings_buildingIdDocuments = z.infer<typeof consumesPostDocumentsBuildings_buildingIdDocuments>

export const paramsPostDocumentsBuildings_buildingIdDocuments = z.object({ "buildingId": z.string().uuid() })
export type ParamsPostDocumentsBuildings_buildingIdDocuments = z.infer<typeof paramsPostDocumentsBuildings_buildingIdDocuments>

export const bodyPostDocumentsBuildings_buildingIdDocuments = z.object({ "attachment": z.object({ "encoding": z.string(), "filename": z.string(), "mimetype": z.string().optional(), "file": z.any(), "type": z.string().optional() }), "name": z.object({ "value": z.string() }).optional(), "description": z.object({ "value": z.string() }).optional() })
export type BodyPostDocumentsBuildings_buildingIdDocuments = z.infer<typeof bodyPostDocumentsBuildings_buildingIdDocuments>

export const responsePostDocumentsBuildings_buildingIdDocuments = z.object({ "payload": z.object({ "id": z.string().uuid(), "buildingId": z.string().uuid(), "name": z.string(), "description": z.string().optional(), "fileName": z.string(), "fileSize": z.string().optional(), "mimeType": z.string().optional(), "uploadedBy": z.string().uuid(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostDocumentsBuildings_buildingIdDocuments = z.infer<typeof responsePostDocumentsBuildings_buildingIdDocuments>

interface IPostDocumentsBuildings_buildingIdDocuments extends BaseMethodType {
  tags: TagsPostDocumentsBuildings_buildingIdDocuments,
  description: DescriptionPostDocumentsBuildings_buildingIdDocuments,
  consumes: ConsumesPostDocumentsBuildings_buildingIdDocuments,
  params: ParamsPostDocumentsBuildings_buildingIdDocuments,
  body: BodyPostDocumentsBuildings_buildingIdDocuments,
  response: ResponsePostDocumentsBuildings_buildingIdDocuments
}
export const tagsGetDocumentsBuildings_buildingIdDocuments = z.any()
export type TagsGetDocumentsBuildings_buildingIdDocuments = z.infer<typeof tagsGetDocumentsBuildings_buildingIdDocuments>

export const descriptionGetDocumentsBuildings_buildingIdDocuments = z.any()
export type DescriptionGetDocumentsBuildings_buildingIdDocuments = z.infer<typeof descriptionGetDocumentsBuildings_buildingIdDocuments>

export const paramsGetDocumentsBuildings_buildingIdDocuments = z.object({ "buildingId": z.string().uuid() })
export type ParamsGetDocumentsBuildings_buildingIdDocuments = z.infer<typeof paramsGetDocumentsBuildings_buildingIdDocuments>

export const responseGetDocumentsBuildings_buildingIdDocuments = z.object({ "payload": z.array(z.object({ "id": z.string().uuid(), "buildingId": z.string().uuid(), "name": z.string(), "description": z.string().optional(), "fileName": z.string(), "fileSize": z.string().optional(), "mimeType": z.string().optional(), "uploadedBy": z.string().uuid(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetDocumentsBuildings_buildingIdDocuments = z.infer<typeof responseGetDocumentsBuildings_buildingIdDocuments>

interface IGetDocumentsBuildings_buildingIdDocuments extends BaseMethodType {
  tags: TagsGetDocumentsBuildings_buildingIdDocuments,
  description: DescriptionGetDocumentsBuildings_buildingIdDocuments,
  params: ParamsGetDocumentsBuildings_buildingIdDocuments,
  response: ResponseGetDocumentsBuildings_buildingIdDocuments
}
export const URL = '/documents/buildings/:buildingId/documents'
export const validation = {
  post: {
    tags: tagsPostDocumentsBuildings_buildingIdDocuments,
    description: descriptionPostDocumentsBuildings_buildingIdDocuments,
    consumes: consumesPostDocumentsBuildings_buildingIdDocuments,
    params: paramsPostDocumentsBuildings_buildingIdDocuments,
    body: bodyPostDocumentsBuildings_buildingIdDocuments,
    response: responsePostDocumentsBuildings_buildingIdDocuments
  },
  get: {
    tags: tagsGetDocumentsBuildings_buildingIdDocuments,
    description: descriptionGetDocumentsBuildings_buildingIdDocuments,
    params: paramsGetDocumentsBuildings_buildingIdDocuments,
    response: responseGetDocumentsBuildings_buildingIdDocuments
  }
}
export interface DocumentsBuildings_buildingIdDocuments extends BaseRouteType {
  post: IPostDocumentsBuildings_buildingIdDocuments,
  get: IGetDocumentsBuildings_buildingIdDocuments
}